import { tv } from "@/utils/tv.config";
import { VariantProps } from "tailwind-variants";

const navigationMenuClasses = tv({
  slots: {
    root: ["Navigation__menu-root", "min-w-max", "rounded-xl", "text-gray-900"],
    list: [
      "Navigation__menu-list",
      "relative",
      "flex",
      "aria-[orientation=vertical]:flex-col",
    ],

    trigger: [
      "Navigation__menu-trigger",
      "box-border",
      "flex",
      "items-center",
      "justify-center",
      "gap-1.5",
      "h-10",
      "px-2",
      "xs:px-3.5",
      "m-0",
      "rounded-xl",
      "text-gray-900",
      "font-regular",
      "text-xs",
      "xs:text-sm",
      "leading-6",
      "select-none",
      "no-underline",
      "whitespace-nowrap",
      "hover:bg-gray-100",
      "active:bg-gray-100",
      "data-[popup-open]:bg-gray-100",
      "focus-visible:outline",
      "focus-visible:outline-2",
      "focus-visible:-outline-offset-1",
      "focus-visible:outline-blue-800",
      "focus-visible:relative",
    ],

    icon: [
      "Nabigation__menu-icon",
      "transition-transform",
      "duration-200",
      "ease-in-out",
      "data-[popup-open]:rotate-180",
    ],

    content: [
      "Nabigation__menu-content",
      // "overflow-y-auto",
      // "w-[calc(100vw_-_40px)]",
      "h-full",
      "p-6",
      // "xs:w-max",
      // "xs:min-w-[400px]",
      "transition-[opacity,transform,translate]",
      "duration-[var(--duration)]",
      "ease-[var(--easing)]",
      "data-[starting-style]:opacity-0",
      "data-[ending-style]:opacity-0",
      "data-[starting-style]:data-[activation-direction=left]:translate-x-[-50%]",
      "data-[starting-style]:data-[activation-direction=right]:translate-x-[50%]",
      "data-[ending-style]:data-[activation-direction=left]:translate-x-[50%]",
      "data-[ending-style]:data-[activation-direction=right]:translate-x-[-50%]",
    ],

    link: [
      "Nabigation__menu-link",
      "block",
      "rounded-lg",
      "p-2",
      "xs:p-3",
      "no-underline",
      "text-inherit",
      "hover:bg-gray-100",
      "focus-visible:relative",
      "focus-visible:outline",
      "focus-visible:outline-2",
      "focus-visible:-outline-offset-1",
      "focus-visible:outline-blue-800",
    ],

    positioner: [
      "Nabigation__menu-positioner",
      "box-border",
      "h-[var(--positioner-height)]",
      // "w-[var(--positioner-width)]",
      "max-w-[var(--available-width)]",
      "transition-[top,left,right,bottom]",
      "duration-[var(--duration)]",
      "ease-[var(--easing)]",
      "before:absolute",
      "before:content-['']",
      "data-[instant]:transition-none",
      "data-[side=bottom]:before:top-[-10px]",
      "data-[side=bottom]:before:right-0",
      "data-[side=bottom]:before:left-0",
      "data-[side=bottom]:before:h-2.5",
      "data-[side=left]:before:top-0",
      "data-[side=left]:before:right-[-10px]",
      "data-[side=left]:before:bottom-0",
      "data-[side=left]:before:w-2.5",
      "data-[side=right]:before:top-0",
      "data-[side=right]:before:bottom-0",
      "data-[side=right]:before:left-[-10px]",
      "data-[side=right]:before:w-2.5",
      "data-[side=top]:before:right-0",
      "data-[side=top]:before:bottom-[-10px]",
      "data-[side=top]:before:left-0",
      "data-[side=top]:before:h-2.5",
    ],

    popup: [
      "Nabigation__menu-popup",
      "max-h-[calc(var(--available-height)-40px)]",
      "bg-common-white",
      "data-[ending-style]:ease-[var(--easing)]",
      "relative",
      "overflow-auto",
      // "h-[var(--popup-height)]",
      // "max-w-[calc(100%_-_40px)]",
      "w-full",
      "max-w-[var(--available-width)]",
      "origin-[var(--transform-origin)]",
      "rounded-xl",
      "bg-[canvas]",
      "text-gray-900",
      "shadow-lg",
      "outline",
      "outline-1",
      "outline-gray-200",
      "transition-[opacity,transform,width,height,scale,translate]",
      "duration-[var(--duration)]",
      "ease-[var(--easing)]",
      "data-[ending-style]:scale-90",
      "data-[ending-style]:opacity-0",
      "data-[ending-style]:duration-150",
      "data-[starting-style]:scale-90",
      "data-[starting-style]:opacity-0",
      // "min-[500px]:w-[var(--popup-width)]",
      // "xs:w-[var(--popup-width)]",
    ],

    arrow: [
      "Nabigation__menu-arrow",
      "flex",
      "transition-[left]",
      "duration-[var(--duration)]",
      "ease-[var(--easing)]",
      "data-[side=bottom]:top-[-8px]",
      "data-[side=left]:right-[-13px]",
      "data-[side=left]:rotate-90",
      "data-[side=right]:left-[-13px]",
      "data-[side=right]:-rotate-90",
      "data-[side=top]:bottom-[-8px]",
      "data-[side=top]:rotate-180",
    ],

    viewport: [
      "Nabigation__menu-viewport",
      "relative",
      "h-full",
      "w-full",
      "overflow-hidden",
    ],
  },
});

export const {
  root: navigationMenuRootClasses,
  list: navigationMenuListClasses,
  trigger: navigationMenuTriggerClasses,
  icon: navigationMenuIconClasses,
  content: navigationMenuContentClasses,
  link: navigationMenuLinkClasses,
  positioner: navigationMenuPositionerClasses,
  popup: navigationMenuPopupClasses,
  arrow: navigationMenuArrowClasses,
  viewport: navigationMenuViewPortClasses,
} = navigationMenuClasses();

export type NavigationMenuVariants = VariantProps<typeof navigationMenuClasses>;
